import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { downloadDocument } from 'src/app/detail-engagement/detail-engagement.component';
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };


@Injectable()
export class DocumentManagementService {
  //baseUrl: String = 'http://localhost:60664/';

  constructor(private _http: HttpClient) {
  }


  getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };

  test(): any {
    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/UploadTest', "documentDetails", httpOptions)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  uploadNewDocument(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/UploadNewDocument', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getDocVersionByDocId(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/GetDocumentVersionByDocId', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }



  getDownloadDocument(downloadModel: any,popupMessage:string) { // reading excel
    const headers = new HttpHeaders();
    var url = environment.APIEndpoint.concat('api/ManageDoc/FetchDocumentFromBlob');
    return this._http.post<Blob>(url, downloadModel, { responseType: 'blob' as 'json' })
      .pipe(
        map((data) => {
          if (data.type != 'text/plain') {
            let file = downloadModel.FileName + downloadModel.FileType;
            if (downloadModel.FileType.toLowerCase() == ".pdf") {
              var blob = new Blob([data], { type: 'application/pdf' });

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, file);
              }
              else {
                //var fileURL = window.URL.createObjectURL(blob);
                var fileURL = environment.APIEndpoint + 'api/Document/download?docId='+downloadModel.DocId+ '&' + 'language='+downloadModel.LanguageCode; 
                var pwa = window.open(fileURL);
                if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
                 alert(popupMessage);
                }
              //   const link = document.createElement('a');
              //   link.href =environment.APIEndpoint + 'api/ManageDoc/download?docId='+downloadModel.DocId+ '&' + 'docVersionId='+downloadModel.DocVersionId  
              //  //link.setAttribute('download', file);
              //   document.body.appendChild(link);
              //   link.click();
                //var w = window.open(fileURL, file);
              //  var w = window.open(fileURL);
                 //w.document.title = 'testing';
                //  w.document.close();

                //setTimeout(function(){ w.document.title =file ; }, 10000);

                //  var title = 'Your Custom Title';
                //   w.onload = function(){
                //  w.document.title = title;
                //  };
                // w.document.write('<title>My PDF File Title</title>');
                //var pwa = window.open(fileURL, file);
                //if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
                //  alert('Please disable your Pop-up blocker and try again.');
                //}
              }
            }
            else {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(data, file);
              }
              else {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([data]));
                link.setAttribute('download', file);
                document.body.appendChild(link);
                link.click();
              }
            }

          }
          else {
            alert('File not found in Blob!');
          }
        })
      );
  }


  
  getDownloadDocumentwithVersion(downloadModel: any,popupMessage:string) { // reading excel
    const headers = new HttpHeaders();
    var url = environment.APIEndpoint.concat('api/ManageDoc/FetchDocumentFromBlob');
    return this._http.post<Blob>(url, downloadModel, { responseType: 'blob' as 'json' })
      .pipe(
        map((data) => {
          if (data.type != 'text/plain') {
            let file = downloadModel.FileName + downloadModel.FileType;
            if (downloadModel.FileType.toLowerCase() == ".pdf") {
              var blob = new Blob([data], { type: 'application/pdf' });

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, file);
              }
              else {
                //var fileURL = window.URL.createObjectURL(blob);
                var fileURL = environment.APIEndpoint + 'api/ManageDoc/download?docId='+downloadModel.DocId+ '&' + 'docVersionId='+downloadModel.DocVersionId; 
                var pwa = window.open(fileURL);
                if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
                 alert(popupMessage);
                }
              //   const link = document.createElement('a');
              //   link.href =environment.APIEndpoint + 'api/ManageDoc/download?docId='+downloadModel.DocId+ '&' + 'docVersionId='+downloadModel.DocVersionId  
              //  //link.setAttribute('download', file);
              //   document.body.appendChild(link);
              //   link.click();
                //var w = window.open(fileURL, file);
              //  var w = window.open(fileURL);
                 //w.document.title = 'testing';
                //  w.document.close();

                //setTimeout(function(){ w.document.title =file ; }, 10000);

                //  var title = 'Your Custom Title';
                //   w.onload = function(){
                //  w.document.title = title;
                //  };
                // w.document.write('<title>My PDF File Title</title>');
                //var pwa = window.open(fileURL, file);
                //if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
                //  alert('Please disable your Pop-up blocker and try again.');
                //}
              }
            }
            else {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(data, file);
              }
              else {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([data]));
                link.setAttribute('download', file);
                document.body.appendChild(link);
                link.click();
              }
            }

          }
          else {
            alert('File not found in Blob!');
          }
        })
      );
  }



  getDocType(): any {

    return this._http.get(environment.APIEndpoint + 'api/ManageDoc/GetDocumentType')
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getDocStatus(): any {

    return this._http.get(environment.APIEndpoint + 'api/ManageDoc/GetDocumentStatus')
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  moveDocFolder(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/MoveDocumentFolder', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  deleteDocVersion(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/DeleteDocumentVersion', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  unapproveDocument(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/UnauthorizeDocument', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getEngagementDocument(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/GetEngagementDocument', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getEngagementApprovedDocument(documentDetails): any {
    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/GetEngagementDocumentWithApproved', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  saveDocumentVersion(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/SaveDocumentVersion', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  approveDocumentVersion(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/ApproveDocumentVersion', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  sendDocumentApprovalMail(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/SendDocumentApprovalMail', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getApproverList(engagementId): any {

    return this._http.get(environment.APIEndpoint + 'api/ManageDoc/GetApproverList?engagementId=' + engagementId)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  logPublicUserDocumentViews(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/ManageDoc/LogPublicUserDocumentViews', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getDocumentApprovalList(showAll:boolean): any {

    return this._http.get(environment.APIEndpoint + 'api/ManageDoc/GetDocumentListForApproval?showAll=' + showAll)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getEngagementListForUser(languageId: any,showAll:boolean): any {
    return this._http.get(environment.APIEndpoint + 'api/ManageDoc/GetEngagementListForUser?languageId=' + languageId + '&&' + 'showAll=' + showAll)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  _errorHandler(error: Response) {
    return Observable.throw(error || 'Server Error');
  }
}
